// Adds form related props to a form control (component)
export default {
	props: {
		value: String,
		label: String,
	},
};
